import CascaderOptionsMulti from './Index.vue'
CascaderOptionsMulti.install = function(Vue) {
  Vue.component(CascaderOptionsMulti.name, CascaderOptionsMulti)
}

export default CascaderOptionsMulti
